import React, { useEffect, useRef, useState } from "react";
import Styles from "./YoutubeVidioPopup.module.css";
import ReactDOM from "react-dom";

interface YoutubeVideoPopupProps {
  onClose: () => void;
  isVisibleVideo: boolean;
  youtubeVideoLink: string;
}

const YoutubeVideoPopup: React.FC<YoutubeVideoPopupProps> = ({
  isVisibleVideo,
  onClose,
  youtubeVideoLink,
}) => {
  const popupRef = useRef<HTMLDivElement>(null);
  const [container, setContainer] = useState<HTMLElement | null>(null);

  const closePopup = () => {
    onClose();
  };

  const getVideoId = (url: string) => {
    const match = url.match(/[?&]v=([^&]+)/);
    return match ? match[1] : url;
  };

  const videoId = getVideoId(youtubeVideoLink);

  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(e.target as Node)) {
        onClose();
      }
    };

    if (isVisibleVideo) {
      if (typeof window !== "undefined") {
        document.body.style.overflow = "hidden";
        document.addEventListener("mousedown", handleOutsideClick);
      } else {
        document.body.style.overflow = "";
      }

      return () => {
        document.body.style.overflow = "";
        document.removeEventListener("mousedown", handleOutsideClick);
      };
    }
  }, [isVisibleVideo, onClose]);
  useEffect(() => {
    const element = document.createElement("div");
    document.body.appendChild(element);
    setContainer(element);

    return () => {
      document.body.removeChild(element);
    };
  }, []);

  if (!container) return null;

  return ReactDOM.createPortal(
    isVisibleVideo && (
      <div
        className={`${Styles.PopupContainer} ${Styles.visible}`}
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <div className={`${Styles.Popup} ${Styles.visible}`} ref={popupRef}>
          <div className={Styles.videoPopup}>
            <span className={Styles.CloseButton} onClick={closePopup}>
              &times;
            </span>
            <iframe
              className={Styles.iFrame}
              src={`https://www.youtube-nocookie.com/embed/${videoId}?modestbranding=1&controls=1&rel=0&showinfo=0&iv_load_policy=3&fs=1&disablekb=1&autoplay=1`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin"
            ></iframe>
          </div>
        </div>
      </div>
    ),
    container
  );
};

export default YoutubeVideoPopup;
